import { render } from "./TwoFAModal.vue?vue&type=template&id=15aec16c&scoped=true"
import script from "./TwoFAModal.vue?vue&type=script&lang=js"
export * from "./TwoFAModal.vue?vue&type=script&lang=js"

import "./TwoFAModal.vue?vue&type=style&index=0&id=15aec16c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15aec16c"]])

export default __exports__